import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Legs2Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M26.2153 1H5.78674C5.27416 1 4.85816 1.42 4.85816 1.9375V5.6875C4.85816 6.205 5.27416 6.625 5.78674 6.625H26.2153C26.7279 6.625 27.1439 6.205 27.1439 5.6875V1.9375C27.1439 1.42 26.7279 1 26.2153 1ZM25.2867 4.75H6.71531V2.875H25.2867V4.75Z"
        fill="currentColor"
      />
      <path
        d="M28.9973 29.9913L27.1402 5.61625C27.103 5.09875 26.5997 4.71625 26.1447 4.75375C25.634 4.79313 25.2515 5.245 25.2905 5.76063L27.0696 29.125H19.5872L16.9185 11.1738C16.8516 10.7144 16.4597 10.375 16.001 10.375C15.5405 10.375 15.1505 10.7144 15.0817 11.1738L12.4149 29.125H4.93245L6.71159 5.76063C6.75059 5.245 6.36802 4.79313 5.85731 4.75375C5.32988 4.72 4.89902 5.10062 4.86002 5.61625L3.00287 29.9913C2.98245 30.2519 3.07159 30.5069 3.24802 30.7C3.42445 30.8913 3.67145 31 3.92959 31H13.2153C13.6759 31 14.0659 30.6606 14.1346 30.2013L16.001 17.6331L17.8693 30.2013C17.9362 30.6606 18.328 31 18.7867 31H28.0725C28.3325 31 28.5776 30.8931 28.754 30.7C28.9305 30.5069 29.0177 30.2519 28.9973 29.9913Z"
        fill="currentColor"
      />
      <path
        d="M10.5744 4.76313C10.0619 4.68438 9.59388 5.03125 9.51216 5.54125C9.48616 5.70063 8.85102 9.4375 5.43016 9.4375C4.91759 9.4375 4.50159 9.8575 4.50159 10.375C4.50159 10.8925 4.91759 11.3125 5.43016 11.3125C9.44902 11.3125 11.0573 7.72563 11.347 5.83C11.425 5.32 11.0796 4.84375 10.5744 4.76313Z"
        fill="currentColor"
      />
      <path
        d="M26.5719 9.4375C23.151 9.4375 22.5159 5.70063 22.488 5.54313C22.4063 5.03313 21.9457 4.68625 21.4257 4.76313C20.9225 4.84375 20.5752 5.32 20.6532 5.83C20.9429 7.72563 22.5512 11.3125 26.5719 11.3125C27.0863 11.3125 27.5005 10.8925 27.5005 10.375C27.5005 9.8575 27.0845 9.4375 26.5719 9.4375Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
